'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
}), exports.compute_operators = exports.departure_time_options = exports.arrival_time_options = exports.departure_time_opts = exports.arrival_time_opts = exports.countries_options = exports.indiastate_options = exports.gender_options = exports.month_options = void 0;

var _entries = require('babel-runtime/core-js/object/entries'),
    _entries2 = _interopRequireDefault(_entries),
    _indiastates = require('./indiastates.json'),
    _indiastates2 = _interopRequireDefault(_indiastates),
    _countries = require('./countries.json'),
    _countries2 = _interopRequireDefault(_countries),
    _monthnames = require('./monthnames.json'),
    _monthnames2 = _interopRequireDefault(_monthnames);

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var month_options = exports.month_options = (0, _entries2.default)(_monthnames2.default).map(function (a) {
  return {
    key: a[0],
    text: a[1],
    value: a[0]
  };
}),
    gender_options = exports.gender_options = [{
  name: 'M',
  label: 'Male',
  value: 'M'
}, {
  name: 'F',
  label: 'Female',
  value: 'F'
}, {
  name: 'U',
  label: 'Unspecified',
  value: 'U'
}],
    indiastate_options = exports.indiastate_options = _indiastates2.default.map(function (b) {
  return {
    name: b,
    label: b,
    value: b
  };
}),
    countries_options = exports.countries_options = _countries2.default.map(function (b) {
  return {
    name: b,
    label: b,
    value: b
  };
}),
    arrival_time_opts = exports.arrival_time_opts = {
  A: 'before 9 am (breakfast at ashram)',
  B: 'between 9am and 2pm (lunch at ashram)',
  C: 'between 2pm and 9pm (dinner at ashram)',
  D: 'after 9pm'
},
    departure_time_opts = exports.departure_time_opts = {
  A: 'before 7am',
  B: 'between 7am and 12noon (after breakfast at ashram)',
  C: 'between 12noon and 7pm (after lunch at ashram)',
  D: 'after 7pm (after dinner at ashram)'
},
    arrival_time_options = exports.arrival_time_options = (0, _entries2.default)(arrival_time_opts).map(function (a) {
  return {
    name: a[0],
    label: a[1]
  };
}),
    departure_time_options = exports.departure_time_options = (0, _entries2.default)(departure_time_opts).map(function (a) {
  return {
    name: a[0],
    label: a[1]
  };
}),
    compute_operators = exports.compute_operators = [{
  name: '>',
  label: 'greater than'
}, {
  name: '<',
  label: 'lesser than'
}, {
  name: '>=',
  label: 'greater than or equals'
}, {
  name: '<=',
  label: 'lesser than or equals'
}, {
  name: '==',
  label: 'equals'
}, {
  name: '!=',
  label: 'not equals'
}];